/**
 * Layer template types
 */

export interface LayerTemplate {
  id: string;
  name: string;
  description?: string | null;
  type?: string;
  is_public: boolean;
  visibility_status_id?: string;
  created_at: string;
  updated_at: string;
  organization_id: string;
  author_id: string;
  editor_id: string;
  author_name?: string;
  editor_name?: string;
}

export interface LayerTemplateList {
  templates: LayerTemplate[];
  total: number;
  page: number;
  size: number;
  pages: number;
}

export interface LayerTemplateDetail extends LayerTemplate {
  properties: LayerTemplateProperty[];
}

export interface LayerTemplateProperty {
  id: string;
  name: string;
  unit?: string | null;
  type: string;
  value: string | number | boolean | null;
  description?: string;
}

export interface LayerTemplateCreate {
  name: string;
  description?: string;
  type?: string;
  is_public: boolean;  // Deprecated, use visibility_status_id
  visibility_status_id?: string;
}

export interface LayerTemplateUpdate {
  name?: string;
  description?: string;
  type?: string;
  is_public?: boolean;  // Deprecated, use visibility_status_id
  visibility_status_id?: string;
}

export interface LayerTemplatePropertyUpdate {
  attribute_id: string;
  value: string | number | boolean | null;
}

export interface LayerTemplateAttributesUpdate {
  properties: LayerTemplatePropertyUpdate[];
}

// Layer type constants
export const LAYER_TYPES = {
  GAS: 'gas',
  OIL: 'oil',
  OIL_AND_GAS: 'oil_and_gas',
} as const;

export type LayerType = typeof LAYER_TYPES[keyof typeof LAYER_TYPES];

// Helper functions
export const getLayerTypeLabel = (type?: string): string => {
  if (!type) return 'Not specified';
  switch (type) {
    case LAYER_TYPES.GAS:
      return 'Gas';
    case LAYER_TYPES.OIL:
      return 'Oil';
    case LAYER_TYPES.OIL_AND_GAS:
      return 'Oil & Gas';
    default:
      return type;
  }
};
